module.exports = __webpack_public_path__ + "static/img/homepage-header-fruity_v3.b579dfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/homepage-header-fruity_v3.jpg
// module id = xye3
// module chunks = 35